import { forwardRef, useState } from "react";
import { InputProps } from "./Input";
import React from "react";
import { EyeCloseIcon, EyeOpenIcon } from "assets/icons";
import styled from "styled-components";
import { InputLayout } from "./Input.styles";

const PasswordInput = forwardRef<HTMLInputElement, InputProps>(
  ({ errorMessage, type, disabled, className, style, ...args }, ref) => {
    const [visible, setVisible] = useState(false);

    const toggleVisibility = () => {
      !disabled && setVisible((pre) => !pre);
    };

    return (
      <PasswordInputLayout
        isError={!!errorMessage ?? false}
        className={className}
        style={style}
      >
        <input
          {...args}
          ref={ref}
          disabled={disabled}
          type={visible ? "text" : "password"}
        />
        {visible ? (
          <EyeOpenIcon onClick={toggleVisibility} />
        ) : (
          <EyeCloseIcon onClick={toggleVisibility} />
        )}
        <label>{errorMessage}</label>
      </PasswordInputLayout>
    );
  },
);

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;

const PasswordInputLayout = styled(InputLayout)`
  position: relative;

  input {
    padding-right: 4.6rem;
  }
  svg {
    position: absolute;
    right: 1.4rem;
    top: 1.2rem;
    transform: translateY(0%);
    width: 2.4rem;
    height: 2.4rem;
    color: ${({ theme }) => theme.color.text.secondary};
  }

  input:disabled + svg {
    color: ${({ theme }) => theme.color.grey[400]};
  }

  label {
    margin-top: 0.6rem;
  }
`;
